import { Modal as ModalModule, UI } from 'common';
import isFunction from 'lodash/isFunction';
import React, { useState } from 'react';

const { WrappedInputTextWithLabel } = UI;
const { Modal, ModalButtonActionType } = ModalModule;

const EditCategoryModal = ({ modalId, data = {} }) => {
	const {
		categoryOptions,
		selectCategory = {},
		type,
		onSaveCategoryCallback,
	} = data;
	const { Name = '', CategoryID = '' } = selectCategory;
	const [validation, setValidation] = useState({
		isValid: null,
		errorMessage: '',
	});
	const [categoryName, setCategoryName] = useState(Name);

	const validate = () => {
		const newValidation = { ...validation };

		if (categoryName === '') {
			newValidation.isValid = false;
			newValidation.errorMessage = 'Category name required.';
		}
		// WEBAPPS-27198, check duplicate categories names (exclude current selecting category)
		else if (
			categoryOptions.some(
				option =>
					option.Name.toLowerCase() === categoryName.toLowerCase() &&
					option.CategoryID !== CategoryID
			)
		) {
			newValidation.isValid = false;
			newValidation.errorMessage = `There is already another category named ${categoryName}`;
		} else {
			newValidation.isValid = true;
			newValidation.errorMessage = '';
		}

		setValidation(newValidation);

		return newValidation.isValid;
	};

	const onSaveCategoryName = closeModal => {
		if (validate()) {
			if (isFunction(onSaveCategoryCallback)) {
				onSaveCategoryCallback(categoryName);
			}
			closeModal();
		}
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Save',
		onClick: onSaveCategoryName,
		dataqa: 'edit-category-save-button',
	};

	return (
		<Modal
			modalId={modalId}
			header={`${type} Category`}
			primaryButton={primaryButton}
			size="small"
		>
			<WrappedInputTextWithLabel
				label="Category Name"
				errorMessage={validation.errorMessage}
				isInputInvalid={validation.isValid === false}
				uiElementConfig={{
					dataqa: 'category-name',
					value: categoryName,
					onBlur: validate,
					maxLength: 20,
					onChange: ({ target: { value } }) => setCategoryName(value),
				}}
			/>
		</Modal>
	);
};

export default EditCategoryModal;
